import type { Logger } from './interfaces/logger.js';
import type { LogFormatter } from './log-formatter.js';

export abstract class LoggerProvider<T> {
  protected constructor(protected readonly logFormatter: LogFormatter<T>) {}

  abstract getLogger(name: string): Logger;
}
